import { Helmet } from 'react-helmet-async';
import ArticleMeta from './ArticleMeta';
import JsonLd from "./JsonLd";

export default function SeoHelmet({ seo }) {
    const og = seo.openGraphMetadata ?? {};
    const publishedTime = og.publishedTime ?? og.published_time;
    const modifiedTime = og.modifiedTime ?? og.modified_time;
    const isArticle = og.ogType === 'article';

    return (
        <>
            <Helmet>
                {seo.title && <title>{seo.title}</title>}
                {seo.description && <meta name="description" content={seo.description} />}
                {seo.canonical && <link rel="canonical" href={seo.canonical} />}
                {seo.robots && <meta name="robots" content={seo.robots} />}
                {!seo.robots && <meta name="robots" content="noindex,follow" />}
                {og.ogTitle && <meta property="og:title" content={og.ogTitle} />}
                {og.ogDescription && <meta property="og:description" content={og.ogDescription} />}
                {og.ogImage && <meta property="og:image" content={og.ogImage} />}
                {og.ogType && <meta property="og:type" content={og.ogType} />}
                {og.ogUrl && <meta property="og:url" content={og.ogUrl} />}
                {og.ogImage && <meta name="twitter:card" content="summary_large_image" />}
                {og.ogTitle && <meta name="twitter:title" content={og.ogTitle} />}
                {og.ogDescription && <meta name="twitter:description" content={og.ogDescription} />}
                {og.ogImage && <meta name="twitter:image" content={og.ogImage} />}
            </Helmet>

            {isArticle && (
                <ArticleMeta
                    publishedTime={publishedTime}
                    modifiedTime={modifiedTime}
                />
            )}

            <JsonLd schemas={seo.schemas} />
        </>
    );
}
